import { render, staticRenderFns } from "./page-loading.vue?vue&type=template&id=3c1a89a2&scoped=true"
import script from "./page-loading.vue?vue&type=script&lang=js"
export * from "./page-loading.vue?vue&type=script&lang=js"
import style0 from "./page-loading.vue?vue&type=style&index=0&id=3c1a89a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_4rliqqz3ui7xo7iaw2ukiguuga/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1a89a2",
  null
  
)

export default component.exports